

$(document).ready(function () {
    let screenWidth = $(window).width();
    let $locumHero = $('.locum .hero-filter');
    // let heroOneLine = "<h1>The career you <strong>love</strong>. The lifestyle you <strong>want</strong>.</h1>";
    // let heroTwoLines = "<h1>The career you <strong>love</strong>. <br />The lifestyle you <strong>want</strong>.</h1>";
    // let heroSubtitle = "<p>Join our community of locum veterinarians who have chosen to work differently.</p>";

    // home page Maxime section
    let signatureOneLine = "<p>Dr. Maxime Meunier<span class='diploma'>, DVM, MBA</span></p>"; 
    let signatureTwoLines = "<p>Dr. Maxime Meunier<span class='diploma'>,<br /> DVM, MBA</span></p>";
    let $signature = $('#maxime .card-signature p');

    if (screenWidth < 1470) {
        // $locumHero.html(heroTwoLines+heroSubtitle);
    } else {
        // $locumHero.html(heroOneLine+heroSubtitle);
    }
    if (screenWidth < 530) {
        $signature.html(signatureTwoLines);
    } else {
        $signature.html(signatureOneLine);
    }
});


$(window).resize(function () {
    let screenWidth = $(window).width();
    let $locumHero = $('.locum .hero-filter');
    // let heroOneLine = "<h1>The career you <strong>love</strong>. The lifestyle you <strong>want</strong>.</h1>";
    // let heroTwoLines = "<h1>The career you <strong>love</strong>. <br />The lifestyle you <strong>want</strong>.</h1>";
    // let heroSubtitle = "<p>Join our community of locum veterinarians who decide to work differently. </p>";

    // home page Maxime section
    let signatureOneLine = "<p>Dr. Maxime Meunier<span class='diploma'>, DVM, MBA</span></p>"; 
    let signatureTwoLines = "<p>Dr. Maxime Meunier<span class='diploma'>,<br /> DVM, MBA</span></p>";
    let $signature = $('#maxime .card-signature p');

    if (screenWidth < 1470) {
        // $locumHero.html(heroTwoLines+heroSubtitle);
    } else {
        // $locumHero.html(heroOneLine+heroSubtitle);
    }
    if (screenWidth < 530) {
        $signature.html(signatureTwoLines);
    } else {
        $signature.html(signatureOneLine);
    }
    
});